import { Meta } from '../../Meta';
import React from 'react';
import { MarketingPage } from '../../marketing/MarketingPage';
import { CaseStudyPostsSection } from './CaseStudyPostsSection';
import { CaseStudyHeroSection } from './CaseStudyHeroSection';

const CASE_STUDY_POSTS = [
  {
    title: 'How Juicebox closes deals faster with the Wolfia AI Trust Center',
    slug: 'juicebox',
    featuredImage: '/images/case-studies/juicebox_x_wolfia.png',
  }
];

export const CaseStudyHome = () => (
  <MarketingPage>
    <Meta title="Case Study">
      <meta property="og:title" content="Wolfia Customer Case Studies" />
      <meta property="og:image" content="/images/meta/og-image.jpg" />
      <meta
        property="og:description"
        content="Learn how companies are using Wolfia to accelerate their deals and assess third-party risk with AI."
      />
    </Meta>
    <CaseStudyHeroSection />
    <CaseStudyPostsSection caseStudies={CASE_STUDY_POSTS} />
  </MarketingPage>
);